<template>
    <div id="app">

        <router-view />

        <!-- <div class="st-footer">
            <div>Copyright © 2022 杭州广立微电子股份有限公司 All Rights Reserved.</div>
            <div>浙ICP备2021003814号-1</div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {};
    }
};
</script>

<style scoped lang="less">
.st-footer {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    line-height: 30px;
    background-color: #1b1b1b;
    color: #fff;
}
/deep/ .el-pagination.is-background .btn-next,
/deep/ .el-pagination.is-background .btn-prev,
/deep/ .el-pagination.is-background .el-pager li {
    width: 40px;
    height: 40px;
    line-height: 40px;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0d288b;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    color: #fff;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #0d288b;
}
/deep/ .el-input.is-active .el-input__inner,
/deep/ .el-input__inner:focus {
    border-color: #0d288b;
}

// 按钮重置
/deep/ .el-button--theme {
    border-color: #0d288b !important;
    background-color: #0d288b !important;
    border-radius: 8px;
    color: #fff;
    span {
        a {
            color: #f3f4f5;
            font-weight: bold;
        }
    }
    &:hover,
    &:focus {
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue